import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class ReportsPublicTemplatesRoute extends Route {
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-reports-public-templates';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.templates = this.mmTemplatesService.requestReportPublicTemplates();

		return hashSettled(promises);
	}
}
